<template>
  <div class="daren">
    <div class="title">
      <img src="../assets/image/tips1_title.jpg" />
    </div>
    <div class="con clearfix">
      <div class="banner1">
        <div class="boxsw">
          <div id="gallery-con" class="gallery-con">
            <div class="swiperUl" :style="anitralate">
              <div class="slide">
                <div class="top topm">
                  <span>
                    <i>混沌牛</i>
                    <p>生态摄影爱好者</p>
                  </span>
                  <img src="../assets/image/tips1_img1.jpg" alt />
                </div>
                <div class="bot">
                  <span>
                    EOS 90D +
                    <br />EF 500mm f/4L IS II USM
                  </span>
                  <div class="move movem" @click="clik(0)">
                    查看图集
                    <span></span>
                  </div>
                </div>
              </div>
              <div class="slide">
                <div class="top topm">
                  <span>
                    <i>甘东海</i>
                    <p>生态摄影爱好者</p>
                  </span>
                  <img src="../assets/image/tips1_img2.jpg" alt />
                </div>
                <div class="bot">
                  <span>
                    EOS 90D +
                    <br />EF 600mm f/4L IS II USM
                  </span>
                  <div class="move movem" @click="clik(1)">
                    查看图集
                    <span></span>
                  </div>
                </div>
              </div>
              <div class="slide">
                <div class="top topm">
                  <span>
                    <i>凌子川</i>
                    <p>知名生态摄影师</p>
                  </span>
                  <img src="../assets/image/tips1_img3.jpg" alt />
                </div>
                <div class="bot">
                  <span>
                    EOS 90D +
                    <br />EF 600mm f/4L IS II USM
                  </span>
                  <div class="move movem" @click="clik(2)">
                    查看图集
                    <span></span>
                  </div>
                </div>
              </div>
              <div class="slide">
                <div class="top topm">
                  <span>
                    <i>蔡培毅</i>
                    <p>生态摄影爱好者</p>
                  </span>
                  <img src="../assets/image/tips1_img4.jpg" alt />
                </div>
                <div class="bot">
                  <span>
                    EOS 1DX II +
                    <br />EF 600mm f/4L IS II USM
                  </span>
                  <div class="move movem" @click="clik(3)">
                    查看图集
                    <span></span>
                  </div>
                </div>
              </div>
              <div class="slide">
                <div class="top topm">
                  <span>
                    <i>AQO</i>
                    <p>佳友在线鸟友版主</p>
                  </span>
                  <img src="../assets/image/tips1_img5.jpg" alt />
                </div>
                <div class="bot">
                  <span>
                    EOS 90D +
                    <br />EF 100-400mm f/4.5-5.6L IS II USM
                  </span>
                  <div class="move movem" @click="clik(4)">
                    查看图集
                    <span></span>
                  </div>
                </div>
              </div>
              <div class="slide">
                <div class="top topm">
                  <span>
                    <i>孙晓宏</i>
                    <p>知名生态摄影师</p>
                  </span>
                  <img src="../assets/image/tips1_img6.jpg" alt />
                </div>
                <div class="bot">
                  <span>
                    EOS 1DX II +
                    <br />EF 800mm f/5.6L IS USM
                  </span>
                  <div class="move movem" @click="clik(5)">
                    查看图集
                    <span></span>
                  </div>
                </div>
              </div>
              <div class="slide">
                <div class="top topm">
                  <span>
                    <i>何晓安</i>
                    <p>自然生态摄影师</p>
                  </span>
                  <img src="../assets/image/tips1_img7.jpg?1234" alt />
                </div>
                <div class="bot">
                  <span>
                    EOS 90D +
                    <br />EF 100-400mm f/4.5-5.6L IS II USM
                  </span>
                  <div class="move movem" @click="clik(6)">
                    查看图集
                    <span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span class="jtl" @click="leftAni" v-show="anijt1">
            <img src="../assets/image/1224jtl.png" />
          </span>
          <span class="jtr" @click="rightAni">
            <img src="../assets/image/1224jtr.png" v-show="anijt2" />
          </span>
        </div>
      </div>
      <!-- 上轮播的分页器 -->
      <!-- <div class="swiper-pagination swiper-pagination3" id="swiper-pagination2" slot="pagination" style="bottom:10px;"></div> -->
      <div class="banner2" @mouseleave="swplay" @mouseenter="swout">
        <div class="atlas" v-if="atlas_boxdisplay">
          <img src="../assets/image/atlas_bj.png" class="bj" />
          <div class="atlas_con">
            <div
              class="listImg"
              v-show="atlas_list.dis"
              v-for="(atlas_list,index) in atlas_list"
              :key="index"
            >
              <div class="delete" @click="del(index)">
                <img src="../assets/image/delete.png" />
              </div>
              <span class="jtl" @click="preClick(index)">
                <img src="../assets/image/atlas_jtl.png" />
              </span>
              <div
                class="imgs"
                v-show="imgs.imgdis"
                v-for="(imgs,index) in atlas_list.banner"
                :key="index"
              >
                <div class="list_imgs">
                  <img :src="imgs.banner" />
                  <div class="botFont">
                    <div class="font">{{imgs.font}}</div>
                  </div>
                </div>
              </div>
              <span class="jtr" @click="nextClick(index)">
                <img src="../assets/image/atlas_jtr.png" />
              </span>
            </div>
          </div>
        </div>
        <swiper :options="swiperOptionSwp2" ref="swiperOptionSwp2" class="gallery-con2">
          <div class="swiper-slide" v-for="(swlistimg,index) in swlistimg" :key="index">
            <div class="leftCon">
              <div class="topCon" @click="atlas(index)">
                <img :src="swlistimg.imgurl1" />
                <span>
                  <img src="../assets/image/moveimg.png" alt />
                </span>
                <div
                  class="fontName"
                  style="position:absolute;left:10px;bottom:10px;color:#fff"
                >{{swlistimg.fontName}}</div>
              </div>
              <a :href="swlistimg.a" target="_blank">
                <div class="autoCon">
                  <div
                    class="fontName"
                    style="position:absolute;left:10px;bottom:10px;color:#fff"
                  >{{swlistimg.fontName2}}</div>
                  <img :src="swlistimg.imgurl2" />
                  <div class="font">
                    <h3 style="font-size:21px">{{swlistimg.fontT}}</h3>
                    <p>{{swlistimg.fontP}}</p>
                  </div>
                </div>
                <div class="botCon">
                  <div
                    class="fontName"
                    style="position:absolute;left:10px;bottom:10px;color:#fff"
                  >{{swlistimg.fontName3}}</div>
                  <div
                    class="fontName"
                    style="position:absolute;left:462px;bottom:10px;color:#fff"
                  >{{swlistimg.fontName4}}</div>
                  <img :src="swlistimg.imgurl3" />
                  <img :src="swlistimg.imgurl4" />
                </div>
              </a>
            </div>
            <a :href="swlistimg.a" target="_blank">
              <div class="rightCon">
                <img :src="swlistimg.imgurl5" />
                <img :src="swlistimg.imgurl6" />
                <div
                  class="fontName"
                  style="position:absolute;left:10px;top:243px;color:#fff"
                >{{swlistimg.fontName5}}</div>
                <div
                  class="fontName"
                  style="position:absolute;left:10px;bottom:10px;color:#fff"
                >{{swlistimg.fontName6}}</div>
              </div>
            </a>
          </div>
          <!-- <div class="swiper-button-prev" id="swiper-button-prev2" slot="button-prev"></div>
          <div class="swiper-button-next" id="swiper-button-next2" slot="button-next"></div>-->
        </swiper>
      </div>
      <div class="swiper-pagination swiper-pagination2" id="swiper-pagination2" slot="pagination"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      anijt1: false,
      anijt2: true,
      // 控制图集最外层的div显示或隐藏
      atlas_boxdisplay: false,
      atlas_list: [
        {
          dis: false,
          banner: [
            {
              imgdis: true,
              banner: require("../assets/image/atlaslist1img1.jpg"),
              font:
                "EOS 90D+EF 100-400mm f/4.5-5.6L IS II USM 光圈 5 快门 1/1600 感光度 250"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist1img2.jpg"),
              font:
                "EOS 90D+EF 100-400mm f/4.5-5.6L IS II USM 光圈 8 快门 1/1250 感光度 500"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist1img3.jpg"),
              font:
                "EOS 90D+EF 100-400mm f/4.5-5.6L IS II USM 光圈 5.6 快门 1/2000 感光度 320"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist1img4.jpg"),
              font:
                "EOS 90D+EF 100-400mm f/4.5-5.6L IS II USM 光圈 5 快门 1/2500 感光度 320"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist1img5.jpg"),
              font:
                "EOS 90D+EF 100-400mm f/4.5-5.6L IS II USM 光圈 6.3 快门 1/2000 感光度 250"
            }
          ]
        },
        {
          dis: false,
          banner: [
            {
              imgdis: true,
              banner: require("../assets/image/atlaslist2img1.jpg"),
              font:
                "EOS 90D+EF 600mm f/4L IS III USM 光圈 4 快门 1/1600 感光度 800"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist2img2.jpg"),
              font:
                "EOS 90D+EF 600mm f/4L IS III USM 光圈 4 快门 1/1600 感光度 4000"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist2img3.jpg"),
              font:
                "EOS 90D+EF 600mm f/4L IS III USM 光圈 4 快门 1/5000 感光度 125"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist2img4.jpg"),
              font:
                "EOS 90D+EF 600mm f/4L IS III USM 光圈 4.5 快门 1/5000 感光度 400"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist2img5.jpg"),
              font:
                "EOS 90D+EF 600mm f/4L IS III USM 光圈 4 快门 1/1600 感光度 800"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist2img6.jpg"),
              font:
                "EOS 90D+EF 600mm f/4L IS III USM 光圈 4 快门 1/1250 感光度 6400"
            }
          ]
        },
        {
          dis: false,
          banner: [
            {
              imgdis: true,
              banner: require("../assets/image/atlaslist3img1.jpg"),
              font:
                "EOS 90D+EF 70-200mm f/2.8L IS II USM 光圈 11 快门1/400感光度4000"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist3img2.jpg"),
              font: "EOS 90D+EF 600mm f/4L IS II USM 光圈 8 快门1/1250感光度640"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist3img3.jpg"),
              font:
                "EOS 90D+EF 600mm f/4L IS II USM 光圈 8 快门1/1250感光度6400"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist3img4.jpg"),
              font:
                "EOS 90D+EF 600mm f/4L IS II USM 光圈 5 快门1/1600感光度6400"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist3img5.jpg"),
              font: "EOS 90D+EF 600mm f/4L IS II USM 光圈 5 快门1/1600感光度500"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist3img6.jpg"),
              font:
                "EOS 90D+EF 70-200mm f/2.8L IS II USM 光圈11快门 1/160  感光度 500"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist3img7.jpg"),
              font:
                "EOS 90D+EF 600mm f/4L IS II USM 光圈7.1快门 1/160  感光度6400"
            }
          ]
        },
        {
          dis: false,
          banner: [
            {
              imgdis: true,
              banner: require("../assets/image/atlaslist4img1.jpg"),
              font:
                "EOS-1D X Mark II+EF 300mm f/2.8L IS II USM 光圈 4.5 快门 1/1600 感光度 250"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist4img2.jpg"),
              font:
                "EOS-1D X Mark II+EF 300mm f/2.8L IS II USM 光圈 2.8 快门 1/2500 感光度 200"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist4img3.jpg"),
              font:
                "EOS-1D X Mark II+EF 600mm f/4L IS II USM+1.4X 光圈 5.6 快门 1/2500 感光度 800"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist4img4.jpg"),
              font:
                "EOS-1D X Mark II+EF 600mm f/4L IS II USM+1.4X 光圈 5.6 快门 1/1250 感光度320"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist4img5.jpg"),
              font:
                "EOS-1D X Mark II+EF 600mm f/4L IS II USM 光圈 4 快门 1/2000 感光度 640"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist4img6.jpg"),
              font:
                "EOS-1D X Mark II+EF 300mm f/2.8L IS II USM 光圈 6.3 快门 1/1600 感光度 1250"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist4img7.jpg"),
              font:
                "EOS-1D X Mark II+EF 600mm f/4L IS II USM 光圈 4 快门 1/800 感光度 500"
            }
          ]
        },
        {
          dis: false,
          banner: [
            {
              imgdis: true,
              banner: require("../assets/image/atlaslist5img1.jpg"),
              font:
                "EOS 90D+EF 100-400mm f/4.5-5.6L IS II USM 1/2500 秒 f/5.6 ISO200"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist5img2.jpg"),
              font:
                "EOS 90D+EF 100-400mm f/4.5-5.6L IS II USM 1/2500 秒 f/5.6  ISO320"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist5img3.jpg"),
              font:
                "EOS-1D X Mark II+EF 600mm f/4L IS II USM+1.4X 光圈 5.6 快门 1/2500 感光度 800"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist5img4.jpg"),
              font:
                "EOS 90D+EF 100-400mm f/4.5-5.6L IS II USM 1/2500 秒 f/6.3  ISO4000"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist5img5.jpg"),
              font: "EOS 90D+EF 500mm f/4L IS II USM 1/3200 秒 f/5  ISO640"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist5img6.jpg"),
              font: "EOS 90D+EF 500mm f/4L IS II USM 1/3200 秒 f/6.3 ISO1250"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist5img7.jpg"),
              font:
                "EOS 90D+EF 100-400mm f/4.5-5.6L IS II USM 1/2500 秒 f/5.6 ISO500"
            }
          ]
        },
        {
          dis: false,
          banner: [
            {
              imgdis: true,
              banner: require("../assets/image/atlaslist6img2.jpg"),
              font: "EOS 1DX II，EF 800/5.6L，F7.1，1/3200秒，ISO 640"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist6img1.jpg"),
              font: "EOS 1DX II，EF 800/5.6L，F6.3，1/2500秒，ISO 400"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist6img3.jpg"),
              font: "EOS 1DX II，EF 800/5.6L，F6.3，1/1600秒，ISO 1250"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist6img4.jpg"),
              font: "EOS 1DX II，EF 800/5.6L，F11，1/2000秒，ISO 2500"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist6img5.jpg"),
              font: "EOS 1DX II，EF 800/5.6L，F6.3，1/1000秒，ISO 500"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist6img6.jpg"),
              font: "EOS R，EF 800/5.6L，F7.1，1/160秒，ISO 640"
            }
          ]
        },
        {
          dis: false,
          banner: [
            {
              imgdis: true,
              banner: require("../assets/image/atlaslist7img1.jpg"),
              font: "EOS 90D+EF100-400L拍摄，快门：1/640s，光圈：F6.3，ISO 2000"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist7img2.jpg"),
              font: "EOS 90D+EF100-400L拍摄，快门：1/640s，光圈：F5.6，ISO 1600"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist7img3.jpg"),
              font: "EOS 90D+EF100-400L拍摄，快门：1/640s，光圈：F6.3，ISO 6400"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist7img4.jpg"),
              font: "EOS 90D+EF100-400L拍摄，快门：1/640s，光圈：F5.6，ISO 1250"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist7img5.jpg"),
              font: "EOS 90D+EF100-400L拍摄，快门：1/250s，光圈：F5.6，ISO 3200"
            },
            {
              imgdis: false,
              banner: require("../assets/image/atlaslist7img6.jpg"),
              font: "EOS 90D+EF100-400L拍摄，快门：1/250s，光圈：F5.6，ISO 2000"
            }
          ]
        }
      ],
      swlistimg: [
        {
          a: "http://article.photofans.cn/article-54959-1.html",
          fontName: "窄脊江豚",
          fontName2: "燕隼",
          fontName3: "矛斑蝗莹",
          fontName4: "黑尾鸥",
          fontName5: "黑尾鸥",
          fontName6: "",
          fontT: "高画质高速新体验 佳能EOS 90D拍鸟赏秋",
          fontP:
            "混沌牛，本名刘振。一位IT从业者，在热爱拍鸟的趋势下不断努力，成为自然观鸟圈大牛，自然生态拍摄达人。作为观鸟中国行极有特点的一站——老铁山站，我们邀请到了自然生态观鸟摄影师刘振，一同拍摄老铁山丰富的鸟类。同时，刘振老师和我们分享了他...",
          imgurl1: require("../assets/image/tips1_botlist1img1.jpg"),
          imgurl2: require("../assets/image/tips1_botlist1img19120501.jpg?2"),
          imgurl3: require("../assets/image/tips1_botlist1img3.jpg"),
          imgurl4: require("../assets/image/tips1_botlist1img4.jpg"),
          imgurl5: require("../assets/image/tips1_botlist1img5.jpg"),
          imgurl6: require("../assets/image/tips1_botlist1img6.jpg")
        },
        {
          a: "http://article.photofans.cn/article-54992-1.html",
          fontT: "难以拒绝的高速高画质 EOS 90D拍鸟记",
          fontName: "雉鸡",
          fontName2: "黑嘴鸥",
          fontName3: "棕头鸦雀",
          fontName4: "",
          fontName5: "麻雀",
          fontName6: "绿背山雀",
          fontP:
            "甘东海，观鸟达人，鸟类生态识别专家，生态摄影达人。作为一个喜欢户外运动的轻量化选手，我户外运动的初衷一直以观鸟为主，能看到鸟就满足了。开始拍鸟都是出于记录的需要，渐渐地，拍鸟也成了我的一种习惯。外出为了节省重量，我平时只携带微单随...",
          imgurl1: require("../assets/image/tips1_botlist2img1.jpg"),
          imgurl2: require("../assets/image/tips1_botlist2img2.jpg"),
          imgurl3: require("../assets/image/tips1_botlist2img3.jpg"),
          imgurl4: require("../assets/image/tips1_botlist2img4.jpg"),
          imgurl5: require("../assets/image/tips1_botlist2img5.jpg"),
          imgurl6: require("../assets/image/tips1_botlist2img6.jpg")
        },
        {
          fontName2: "黑白疣猴",
          fontName3: "斑鼠鸟",
          fontName4: "斑鸽",
          fontName5: "黑白噪犀鸟",
          fontName6: "橙巧织雀",
          a: "http://article.photofans.cn/article-55140-1.html",
          fontT: "高速高画质的半幅机皇 EOS 90D探索非洲秘境",
          fontP:
            "摄影师凌子川，资深拍鸟达人，知名生态摄影师，擅长生态与人文纪实摄影，尤其热爱鸟类摄影，从他拍鸟的作品中能感受到他在拍摄鸟类时的热情，以及对于器材的深入了解与纯熟运用。作为老牌佳能用户，凌子川老师能熟练使用手中的器材，记录精彩的瞬间。这次他带着佳能EOS 90D前往...",
          imgurl1: require("../assets/image/tips1_botlist3img1.jpg"),
          imgurl2: require("../assets/image/tips1_botlist3img2.jpg"),
          imgurl3: require("../assets/image/tips1_botlist3img3.jpg"),
          imgurl4: require("../assets/image/tips1_botlist3img4.jpg"),
          imgurl5: require("../assets/image/tips1_botlist3img5.jpg"),
          imgurl6: require("../assets/image/tips1_botlist3img6.jpg")
        },
        {
          // fontName2: "黑白疣猴",
          // fontName3: "斑鼠鸟",
          // fontName4: "斑鸽",
          // fontName5: "黑白噪犀鸟",
          // fontName6: "橙巧织雀",
          a: "http://article.photofans.cn/article-55211-1.html",
          fontT: "生态急速捕手 蔡培毅老师和他的拍鸟利器EOS1DX Mark II",
          fontP:
            "蔡培毅老师从事摄影行业多年，一直是佳能器材的忠实用户，近些年他涉足生态摄影领域，尤其是专注于鸟类生态摄影，和很多拍鸟人一样经常在全国各地创作，这次他带着佳能EOS1DX Mark II外出创作，让我们一起...",
          imgurl1: require("../assets/image/tips1_botlist4img1.jpg"),
          imgurl2: require("../assets/image/tips1_botlist4img2.jpg"),
          imgurl3: require("../assets/image/tips1_botlist4img3.jpg"),
          imgurl4: require("../assets/image/tips1_botlist4img4.jpg"),
          imgurl5: require("../assets/image/tips1_botlist4img5.jpg"),
          imgurl6: require("../assets/image/tips1_botlist4img6.jpg")
        },
        {
          fontName: "凤头蜂鹰",
          fontName2: "凤头蜂鹰",
          fontName3: "俯冲的苍鹰",
          fontName4: "凤头蜂鹰",
          fontName5: "凤头蜂鹰",
          fontName6: "凤头蜂鹰",
          a: "http://article.photofans.cn/article-55242-1.html",
          fontT: "高性价比拍鸟利器 佳能EOS 90D老铁山拍鸟试用",
          fontP:
            "AQO：中国艺术摄影协会会员，北京摄影家协会会员，中国百姓摄影协会理事，佳友在线鸟友版主，友爱国际摄影大赛友爱奖得主。",
          imgurl1: require("../assets/image/tips1_botlist5img1.jpg"),
          imgurl2: require("../assets/image/tips1_botlist5img2.jpg?2"),
          imgurl3: require("../assets/image/tips1_botlist5img3.jpg"),
          imgurl4: require("../assets/image/tips1_botlist5img4.jpg"),
          imgurl5: require("../assets/image/tips1_botlist5img5.jpg"),
          imgurl6: require("../assets/image/tips1_botlist5img6.jpg")
        },
        {
          a: "http://article.photofans.cn/article-55291-1.html",
          fontT: "“误入歧途”拍了鸟 对话生态摄影人孙晓宏",
          fontP:
            "孙晓宏老师，网名“和平里的孩子”，空军某部政委，退休后“误入歧途”成了生态摄影人，之后“越陷越深”，又成为了中国野生动物保护协会生态影像委员会副秘书长、中国野生动物保护协会资深会员、美丽德宏生态宣传大使、爱鸟国际高级顾问。不过，和...",
          imgurl1: require("../assets/image/tips1_botlist6img1.jpg?1235123"),
          imgurl2: require("../assets/image/tips1_botlist6img2.jpg?125632"),
          imgurl3: require("../assets/image/tips1_botlist6img3.jpg"),
          imgurl4: require("../assets/image/tips1_botlist6img4.jpg"),
          imgurl5: require("../assets/image/tips1_botlist6img5.jpg"),
          imgurl6: require("../assets/image/tips1_botlist6img6.jpg")
        },
        {
          a: "http://article.photofans.cn/article-55396-1.html",
          fontT: "“轻便全能 佳能EOS 90D生态拍摄实战",
          fontP:
            "何晓安，自然生态摄影师，四川省卧龙国家级自然保护区管理机构一名拥有近30年工龄的工作人员。2015年6月起，在工作之余开始专注卧龙野生动植物资源的观察记录和自然拍摄。2016年10月，长篇报告文学《绿野的守望——卧龙大熊猫保护...",
          imgurl1: require("../assets/image/tips1_botlist7img1.png"),
          imgurl2: require("../assets/image/tips1_botlist7img2.png"),
          imgurl3: require("../assets/image/tips1_botlist7img3.png"),
          imgurl4: require("../assets/image/tips1_botlist7img4.png"),
          imgurl5: require("../assets/image/tips1_botlist7img5.png"),
          imgurl6: require("../assets/image/tips1_botlist7img6.png")
        }
      ],
      swiperOptionSwp2: {
        loop: false,
        autoplay: {
          //播放时间间隔
          delay: 3000,
          disableOnInteraction: false
        },
        lazy: {
          loadPrevNext: true
        },
        pagination: {
          el: ".swiper-pagination2",
          clickable: true
        }
      },
      swiperOptionSwp3: {
        slidesPerView: 4,
        navigation: {
          nextEl: "#swiper-button-next2",
          prevEl: "#swiper-button-prev2"
        },
        //   autoplay: {
        //     //播放时间间隔
        //     delay: 3000,
        //     disableOnInteraction: false
        //   }
        //   autoplay: false,
        //   loop: false
        spaceBetween: 19
        // pagination: {
        //   el: ".swiper-pagination3",
        //   clickable: true
        // }
      },
      anitralate: {
        transform: ""
      },
      // 切换页数的index
      zIndex: 0,
      // 操控对应图集的index
      imgIndex: 0
    };
  },
  created() {
    // function keep(num) {
    //   var res = parseFloat(num);
    //   console.log(res);
    //   if (isNaN(res)) {
    //     alert("传递错误");
    //     return;
    //   }
    //   var res = Math.round(num * 100) / 100;
    //   return res;
    // }
    // console.log(keep(55.3248));
  },
  methods: {
    leftAni() {
      this.anijt1 = false;
      this.anijt2 = true;
      this.anitralate.transform = `translateX(0)`;
    },
    rightAni() {
      this.anijt1 = true;
      this.anijt2 = false;
      this.anitralate.transform = `translateX(-918px)`;
    },
    //按钮切换图片
    preClick(index) {
      // 所处图集的index
      const banenrlength = this.atlas_list[index].banner.length - 1;
      const images = this.atlas_list[index].banner;
      this.imgIndex = index;
      for (let key in images) {
        images[key].imgdis = false;
      }
      if (this.zIndex <= 0) {
        this.zIndex = banenrlength;
        images[this.zIndex].imgdis = true;
      } else {
        this.zIndex--;
        images[this.zIndex].imgdis = true;
      }
    },
    nextClick(index) {
      const banenrlength = this.atlas_list[index].banner.length - 1;
      const images = this.atlas_list[index].banner;
      this.imgIndex = index;
      for (let key in images) {
        images[key].imgdis = false;
      }
      if (this.zIndex == banenrlength) {
        this.zIndex = 0;
        images[this.zIndex].imgdis = true;
      } else {
        this.zIndex++;
        images[this.zIndex].imgdis = true;
      }
    },
    clik(index) {
      this.$refs.swiperOptionSwp2.swiper.slideTo(index, 1000, false);
    },
    atlas(index) {
      this.atlas_boxdisplay = true;
      // 防止图集没有关闭就打开新的图集出现没有反应的状况
      for (let key in this.atlas_list) {
        this.atlas_list[key].dis = false;
      }
      this.atlas_list[index].dis = true;
    },
    del(index) {
      this.atlas_boxdisplay = false;
      this.atlas_list[index].dis = false;
      this.zIndex = 0;
      // 关闭时候让每个图集恢复初始，默认第一个图片显示，其余隐藏
      for (let key in this.atlas_list[this.imgIndex].banner) {
        this.atlas_list[this.imgIndex].banner[key].imgdis = false;
      }
      this.atlas_list[this.imgIndex].banner[0].imgdis = true;
    },
    swout() {
      this.$refs.swiperOptionSwp2.swiper.autoplay.stop();
    },
    swplay() {
      this.$refs.swiperOptionSwp2.swiper.autoplay.start();
    }
  }
};
</script>
<style scoped>
/* ----------------------------------------------达人-------------------------------------- */
.daren {
  position: relative;
  float: left;
  width: 100%;
}
.daren .title {
  float: left;
  min-width: 1200px;
  max-width: 1920px;
  width: 100%;
  text-align: center;
}
.daren .title img {
  width: 1200px;
  margin: 0 auto;
}
.con {
  float: left;
  min-width: 1200px;
  max-width: 1920px;
  width: 100%;
  height: 1473px;
  background: url(../assets/image/tips1_con.jpg) no-repeat center;
  background-size: cover;
}
.banner1 {
  position: relative;
  float: left;
  width: 100%;
  height: 570px;
  min-width: 1200px;
  max-width: 1920px;
}
.banner1 span[class^="jt"] {
  position: absolute;
  top: 45%;
  transform: translateY(-50%);
  width: 50px;
  cursor: pointer;
}
.banner1 span[class^="jt"] img {
  float: left;
  width: 100%;
}
.banner1 .jtl {
  left: -70px;
}
.banner1 .jtr {
  right: -70px;
}
.banner1 .boxsw {
  position: relative;
  margin: 49px auto 0 auto;
  width: 1200px;
  height: 100%;
}
.gallery-con {
  margin: 49px auto 0 auto;
  width: 1200px;
  height: 100%;
  overflow: hidden;
}
.swiperUl {
  float: left;
  width: 999%;
  height: 100%;
  transition: all 0.3s;
}

.gallery-con .slide {
  float: left;
  /* width: 10px; */
  margin-right: 19px;
  width: 286px;
  perspective: 500px;
}
.gallery-con .slide .top {
  position: relative;
  z-index: 99;
  float: left;
  width: 100%;
  height: 373px;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
}
.gallery-con .slide .top img {
  float: left;
  width: 100%;
  height: 100%;
}
.gallery-con .slide .top span {
  position: absolute;
  display: block;
  top: 8px;
  padding: 10px 5px 10px 15px;
  border-left: 5px solid #8cbb3b;
  background: rgba(0, 0, 0, 0.3);
  left: 0px;
}
.gallery-con .slide .top span i {
  color: #fff;
  font-size: 22px;
}
.gallery-con .slide .top span p {
  margin-top: 2px;
  color: #fff;
  font-size: 16px;
}
.gallery-con .slide:hover .topm {
  /* width: 500px; */
  -moz-transform: rotateY(0) rotateX(3deg) rotateZ(0) scale(1.01);
  -webkit-transform: rotateY(0) rotateX(3deg) rotateZ(0) scale(1.01);
  -ms-transform: rotateY(0) rotateX(3deg) rotateZ(0) scale(1.01);
  -o-transform: rotateY(0) rotateX(3deg) rotateZ(0) scale(1.01);
  transform: rotateY(0) rotateX(3deg) rotateZ(0) scale(1.01);
  -webkit-box-shadow: 0 2px 15px rgb(0, 0, 0, 0.4);
  -moz-box-shadow: 0 2px 15px rgb(0, 0, 0, 0.4);
  -ms-box-shadow: 0 2px 15px rgb(0, 0, 0, 0.4);
  -o-box-shadow: 0 2px 15px rgb(0, 0, 0, 0.4);
  box-shadow: 0 2px 15px rgb(0, 0, 0, 0.4);
}
.gallery-con .slide .bot {
  position: relative;
  float: left;
  width: 100%;
  height: 147px;
  border-bottom: 2px solid #d2d2d2;
  border-left: 2px solid #d2d2d2;
  border-right: 2px solid #d2d2d2;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  box-sizing: border-box;
  background: #fff;
}
.gallery-con .slide .bot span {
  float: left;
  color: #000;
  font-size: 18px;
  margin: 15px 0 0 10px;
  font-family: siyuan2;
}
.gallery-con .slide .bot .move {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  bottom: 33px;
  /* background: #f08200; */
  border: 1px solid #f08200;
  color: #f08200;
  font-size: 14px;
  width: 134px;
  text-align: center;
  height: 36px;
  line-height: 36px;
  border-radius: 3px;
  cursor: pointer;
}
.gallery-con .slide .bot .movem:hover {
  color: #fff;
  background: #f08200;
}
.gallery-con .slide .bot .movem:hover span {
  transform: rotate(45deg) translateY(0);
  -webkit-transform: rotate(45deg) translateY(0);
  -moz-transform: rotate(45deg) translateY(0);
  -ms-transform: rotate(45deg) translateY(0);
  -o-transform: rotate(45deg) translateY(0);
  opacity: 1;
}
.gallery-con .slide .bot .move span {
  position: absolute;
  opacity: 0;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  width: 10px;
  height: 10px;
  border: 1px solid #f3972b;
  border-top: 0;
  border-left: 0;
  bottom: -20px;
  left: 37%;
  transform: translateX(-50%) rotate(45deg) translateY(-10px);
  -webkit-transform: translateX(-50%) rotate(45deg) translateY(-10px);
  -moz-transform: translateX(-50%) rotate(45deg) translateY(-10px);
  -ms-transform: translateX(-50%) rotate(45deg) translateY(-10px);
  -o-transform: translateX(-50%) rotate(45deg) translateY(-10px);
}
.banner2 {
  position: relative;
  float: left;
  margin-top: 55px;
  width: 100%;
  height: 788px;
}
.atlas {
  position: absolute;
  z-index: 99;
  width: 1100px;
  height: 600px;
  left: 50%;
  top: 46%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
}
.atlas .bj {
  float: left;
  width: 100%;
}
.atlas_con {
  position: absolute;
  top: 6px;
  left: 6px;
  width: 1089px;
  height: 589px;
  overflow: hidden;
}
.atlas_con .listImg,
.atlas_con .listImg .imgs,
.atlas_con .listImg .imgs .list_imgs {
  position: relative;
  float: left;
  width: 100%;
  height: 100%;
}
.atlas_con .listImg .imgs .list_imgs .botFont {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 70px;
  background-image: linear-gradient(
    180deg,
    transparent 0,
    rgba(0, 0, 0, 0) 10%,
    rgba(0, 0, 0, 0) 15%,
    rgba(0, 0, 0, 0) 20%,
    rgba(0, 0, 0, 0.05) 25%,
    rgba(0, 0, 0, 0.1) 30%,
    rgba(0, 0, 0, 0.15) 35%,
    rgba(0, 0, 0, 0.2) 40%,
    rgba(0, 0, 0, 0.25) 45%,
    rgba(0, 0, 0, 0.3) 60%,
    rgba(0, 0, 0, 0.35) 80%,
    rgba(0, 0, 0, 0.4)
  );
  background-image: -webkit-linear-gradient(
    180deg,
    transparent 0,
    rgba(0, 0, 0, 0) 10%,
    rgba(0, 0, 0, 0.03) 15%,
    rgba(0, 0, 0, 0.04) 20%,
    rgba(0, 0, 0, 0.05) 25%,
    rgba(0, 0, 0, 0.1) 30%,
    rgba(0, 0, 0, 0.15) 35%,
    rgba(0, 0, 0, 0.2) 40%,
    rgba(0, 0, 0, 0.25) 45%,
    rgba(0, 0, 0, 0.3) 60%,
    rgba(0, 0, 0, 0.35) 80%,
    rgba(0, 0, 0, 0.4)
  );
  background-image: -o-linear-gradient(
    180deg,
    transparent 0,
    rgba(0, 0, 0, 0) 10%,
    rgba(0, 0, 0, 0.03) 15%,
    rgba(0, 0, 0, 0.04) 20%,
    rgba(0, 0, 0, 0.05) 25%,
    rgba(0, 0, 0, 0.1) 30%,
    rgba(0, 0, 0, 0.15) 35%,
    rgba(0, 0, 0, 0.2) 40%,
    rgba(0, 0, 0, 0.25) 45%,
    rgba(0, 0, 0, 0.3) 60%,
    rgba(0, 0, 0, 0.35) 80%,
    rgba(0, 0, 0, 0.4)
  );
  background-image: -moz-linear-gradient(
    180deg,
    transparent 0,
    rgba(0, 0, 0, 0) 10%,
    rgba(0, 0, 0, 0.03) 15%,
    rgba(0, 0, 0, 0.04) 20%,
    rgba(0, 0, 0, 0.05) 25%,
    rgba(0, 0, 0, 0.1) 30%,
    rgba(0, 0, 0, 0.15) 35%,
    rgba(0, 0, 0, 0.2) 40%,
    rgba(0, 0, 0, 0.25) 45%,
    rgba(0, 0, 0, 0.3) 60%,
    rgba(0, 0, 0, 0.35) 80%,
    rgba(0, 0, 0, 0.4)
  );
  background-image: -ms-linear-gradient(
    180deg,
    transparent 0,
    rgba(0, 0, 0, 0) 10%,
    rgba(0, 0, 0, 0.03) 15%,
    rgba(0, 0, 0, 0.04) 20%,
    rgba(0, 0, 0, 0.05) 25%,
    rgba(0, 0, 0, 0.1) 30%,
    rgba(0, 0, 0, 0.15) 35%,
    rgba(0, 0, 0, 0.2) 40%,
    rgba(0, 0, 0, 0.25) 45%,
    rgba(0, 0, 0, 0.3) 60%,
    rgba(0, 0, 0, 0.35) 80%,
    rgba(0, 0, 0, 0.4)
  );
}
.atlas_con .listImg .imgs .list_imgs .botFont .font {
  float: left;
  margin-left: 15px;
  height: 100%;
  line-height: 85px;
  color: #fff;
  font-size: 18px;
}
.atlas_con .listImg .jtl,
.atlas_con .listImg .jtr {
  position: absolute;
  width: 33px;
  height: 62px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  z-index: 10;
  cursor: pointer;
}
.atlas_con .listImg .jtl img,
.atlas_con .listImg .jtr img {
  float: left;
  width: 100%;
}
.atlas_con .listImg .jtl {
  left: 30px;
}
.atlas_con .listImg .jtr {
  right: 30px;
}
.atlas_con .delete {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
  cursor: pointer;
}
.atlas_con .delete img {
  float: left;
  width: 54px;
}

.atlas_con .listImg .imgs img {
  float: left;
  width: 100%;
  height: 100%;
}
.gallery-con2 {
  position: absolute;
  left: 50%;
  margin-left: -600px;
  width: 1200px;
  height: 788px;
}
.gallery-con2 .swiper-slide {
  width: 100%;
  height: 728px;
}
.gallery-con2 .swiper-slide .leftCon {
  float: left;
  width: 742px;
  height: 100%;
}
.gallery-con2 .swiper-slide .leftCon .topCon {
  position: relative;
  float: left;
  width: 100%;
  height: 278px;
  cursor: pointer;
}
.gallery-con2 .swiper-slide .leftCon .topCon img {
  float: left;
  width: 100%;
  height: 100%;
}
.gallery-con2 .swiper-slide .leftCon .topCon span {
  position: absolute;
  right: 0;
  bottom: 8px;
  width: 135px;
  height: 39px;
}

.gallery-con2 .swiper-slide .leftCon .autoCon {
  position: relative;
  float: left;
  width: 100%;
  height: 211px;
  margin: 6px 0;
}
.gallery-con2 .swiper-slide .leftCon .autoCon img {
  float: left;
  width: 294px;
  height: 100%;
}
.gallery-con2 .swiper-slide .leftCon .autoCon .font {
  float: right;
  height: 100%;
  margin-right: 5px;
  width: 425px;
}
.gallery-con2 .swiper-slide .leftCon .autoCon .font h3 {
  margin: 15px 0px 0 0;
  width: 101%;
  font-family: siyuan2;
  font-size: 22px;
  color: #000;
}
.gallery-con2 .swiper-slide .leftCon .autoCon .font p {
  margin: 10px 0 0 0;
  line-height: 28px;
}
.gallery-con2 .swiper-slide .leftCon .botCon {
  position: relative;
  float: left;
  width: 100%;
  height: 226px;
}
.gallery-con2 .swiper-slide .leftCon .botCon img {
  float: left;
}
.gallery-con2 .swiper-slide .leftCon .botCon img:last-child {
  float: right;
}
.gallery-con2 .swiper-slide .rightCon {
  position: relative;
  float: right;
  width: 448px;
}
.gallery-con2 .swiper-slide .rightCon img {
  float: left;
  width: 100%;
}
.gallery-con2 .swiper-slide .rightCon img:first-child {
  margin-bottom: 6px;
}
</style>